<template>
  <div>
    <z-centralized-toolbar>
      <!-- <v-toolbar-items> -->
        <v-btn
          depressed
          rounded
          color="primary"
          :to="{ name: 'ClientesAdicionar' }"
          :disabled="!$auth.temPermissao('clientes:cadastrar')"
        >
          <v-icon left>{{ $icon.ADICIONAR_CLIENTE }}</v-icon>Adicionar Cliente
        </v-btn>

        <z-menu-impressoes
          label="Relatórios"
          sublabel="Impressões"
          :itens="impressoes" 
          @abrir:relatorio="() => {}"
        ></z-menu-impressoes>

        <v-btn
          id="btAtualizar"
          icon
          @click="listar"
          :loading="$store.state.loading"
        >
          <v-icon>refresh</v-icon>
          <v-tooltip bottom activator="#btAtualizar">
            Atualizar
          </v-tooltip>
        </v-btn>
      <!-- </v-toolbar-items> -->

      <!-- <v-spacer></v-spacer> -->

      <div style="width: 300px;" class="ml-5">
        <v-text-field
          rounded
          outlined
          single-line
          dense
          autofocus
          clearable
          hide-details
          placeholder="Pesquisar"
          prepend-inner-icon="search"
          v-model="search"
        ></v-text-field>
      </div>

      <v-btn-toggle
        v-show="false"
        v-model="listagem"
        mandatory
        class="elevation-1"
      >
        <v-btn value="Recentes" text>Recentes</v-btn>
        <v-btn value="Todos" text>Todos</v-btn>
      </v-btn-toggle>
    </z-centralized-toolbar>

    <z-container>
      <h3 class="text-body-1 mb-3">Clientes</h3>

      <v-card>
        <v-data-table
          sort-by="razao"
          :items-per-page="15"
          :footer-props="$globals.FOOTER_PROPS"
          :headers="headers"
          :items="clientes"
          item-key="id"
          :loading="false"
          :search="search"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.razao }}</td>
              <td>{{ props.item.telefone }}</td>
              <td>{{ props.item.prazo }}</td>
              <td class="text-center">
                <v-btn
                  icon
                  @click="editar(props.item)"
                  class="ma-0"
                  :disabled="!$auth.temPermissao('clientes:alterar')"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="perguntarExcluir(props.item)"
                  class="ma-0"
                  :disabled="!$auth.temPermissao('clientes:excluir')"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </z-container>

    <z-dialogo
      ref="dialogoExcluir"
      titulo="Deseja excluir esse cliente?"
      :dividers="true"
      largura="500px"
    >
      <div slot="texto">
        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-icon color="primary">mail</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ cliente.razao }}</v-list-item-title>
              <v-list-item-subtitle>Razão Social</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider inset v-show="cliente.telefone"></v-divider>

          <v-list-item v-show="cliente.telefone">
            <v-list-item-action>
              <v-icon color="primary">phone</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ cliente.telefone }}</v-list-item-title>
              <v-list-item-subtitle>Telefone</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>

      <v-btn text @click="$refs.dialogoExcluir.fechar()" :disabled="excluindo"
        >Cancelar</v-btn
      >
      <v-btn
        color="primary"
        text
        @click="confirmarExcluir"
        :loading="excluindo"
        :disabled="excluindo"
        >Excluir</v-btn
      >
    </z-dialogo>

    <z-dialogo-sim-nao
      ref="dialogoRemoverCliente"
      titulo="Remover cliente?"
      botaoSim="Remover"
      botaoNao="Cancelar"
      :loading="excluindo"
    >
      O cliente será removido.
    </z-dialogo-sim-nao>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      // globals,
      headers: [
        { text: "Código", value: "id", width: "150px" },
        { text: "Razão Social", value: "razao" },
        { text: "Telefone", value: "telefone" },
        { text: "Prazo", value: "prazo" },
        {
          text: "Opções",
          value: "",
          width: "200px",
          align: "center",
          sortable: false,
        },
      ],
      search: "",
      pagination: {},
      excluindo: false,
      cliente: {},
      listagem: "Recentes",
      impressoes: [
        { texto: 'Telefones dos Clientes', acao: () => {}, visible: this.$auth.isAdmin() },

      ],
    };
  },

  created() {
    this.listar();
  },

  mounted() {
    this.setTitulo("Cadastro de Clientes");
  },

  methods: {
    ...mapMutations(["setTitulo"]),
    ...mapActions("clientes", ["listar", "excluir", "abrir"]),

    async editar(cliente) {
      await this.abrir(cliente.id);
      this.$router.push({ name: "ClientesEditar", params: { id: cliente.id } });
    },

    perguntarExcluir(cliente) {
      this.cliente = cliente;
      this.$refs.dialogoRemoverCliente.abrir().then(async (response) => {
        if (response == true) await this.confirmarExcluir();
      });
    },

    async confirmarExcluir() {
      try {
        this.excluindo = true;
        await this.excluir(this.cliente.id);
        this.$eventbus.notificar("Cliente excluído com sucesso!");
      } finally {
        this.$refs.dialogoExcluir.fechar();
        this.excluindo = false;
      }
    },
  },

  computed: {
    ...mapState("clientes", ["clientes"]),
  },
};
</script>

<style scoped></style>
